import { ApiRequest, PagedList } from 'framework/api';
import { ServiceLite } from 'framework/entities/service';

export type SearchServicesByNameArgs = {
	accountId: string;
	name: string;
};

export type GetAccountResponsibleTeamResponse = {
	responsibleTeamId: string;
};

export type CreateServiceArgs = {
	accountId: string;
	payload: {
		name: string;
		description: string | null;
		information: string;
		teamIds: string[];
		tags: string[];
		shared: boolean;
		operatingSchedule: {
			timeZone: string;
		};
	};
};

export type CreateServiceResponse = {
	id: string;
};

export function searchServicesByName({ accountId, name }: SearchServicesByNameArgs) {
	return new ApiRequest<PagedList<ServiceLite>>({
		method: 'POST',
		url: 'services/search/lite',
		accountBased: true,
		accountId,
		includeSubaccounts: false,
		payload: {
			filter: {
				logic: 'and',
				filters: [{ field: 'name', operator: 'eq', value: name }],
			},
		},
	});
}

export function getAccountResponsibleTeam(accountId: string) {
	return new ApiRequest<GetAccountResponsibleTeamResponse>({
		url: '',
		accountBased: true,
		accountId,
	});
}

export function createService({ accountId, payload }: CreateServiceArgs) {
	return new ApiRequest<CreateServiceResponse>({
		url: 'services',
		accountBased: true,
		accountId,
		payload,
	});
}
